import styled from "styled-components";

import { Chip as MuiChip } from "@mui/material";
import { TextField as MuiTextField } from "@mui/material";
import { InputLabel, Select } from "@mui/material";

export const Subheader = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #0f0f1e99;
  /* opacity: 0.6; */
`;

export const Layout = styled.div`
  min-width: 240px;
  border: solid 1px #e8e8e8;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
`;

export const LayoutTitle = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #191c1a;
`;

export const Chip = styled(MuiChip)`
  width: fit-content;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
  color: #191c1a;
`;

export const Typography = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #0f0f1e99;
  opacity: 0.6;
  margin: 0;
`;

export const Selector = styled.div`
  border: solid 1px #3024e1;
  border-radius: 12px;
  padding: "16px";
  background-color: "#3024E10A";
  color: "#3024E1";
  font-weight: "600";
  font-size: "14px";
  cursor: "pointer";
`;

export const StyledSelect = styled(Select)`
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 8px;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgb(121, 121, 121);
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  color: #a2a2a2;

  & .Mui-focused {
    color: blue;
  }
`;

export const StyledTextField = styled(MuiTextField)`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-radius: 8px;
    }

    &:hover fieldset {
      border-color: rgb(121, 121, 121);
    }

    &.Mui-focused fieldset {
      border-width: 1px;
    }
  }

  & .MuiInputLabel-root {
    color: #a2a2a2;
  }
`;
